import { Component, Input, OnInit } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ActivatedRoute, Router } from "@angular/router";

@Component({
  selector: "app-ftp-bulk-upload",
  templateUrl: "./ftp-bulk-upload.component.html",
  styleUrls: ["./ftp-bulk-upload.component.css"],
})
export class FtpBulkUploadComponent implements OnInit {
  @Input() title: string;
  @Input() message: string;
  @Input() btnOkText: string;
  @Input() btnViewLogText: string;

  constructor(private activeModal: NgbActiveModal, private route: Router,) {}

  ngOnInit() {}

  public accept() {
    this.activeModal.close(true);
  }
  public viewLog() {
    this.activeModal.dismiss();
    this.route.navigate(["/AdminPanel/FTP-logs"], {});
  }

  public dismiss() {
    this.activeModal.dismiss();
  }
}
